import "./styles/ModalStyle.scss";
import ModalRoute from "./ModalRoute";
import { useSelector } from "react-redux";
import ModalBoundary from "./ModalBoundary";
import { AppState } from "../../RootReducer";
import { RouteComponentProps, useHistory, useLocation } from "react-router";
import { useEffect, useState } from "react";
import { ContentfulState } from "../../contenful/ContentfulReducer";
import { UserState } from "../../user/UserReducer";
import { UserJourneyState } from "../../journey/UserJourneyReducer";
import { setModalPath } from "./utils";
import { VerifyPrincipalStatus } from "../../http/Types";

import TermsAndConditionModal from "./modals/TermsAndConditionModal";
import RegisterSuccessModal from "./modals/RegisterSuccessModal";
import RecoverPasswordModal from "./modals/RecoverPasswordModal";
import RegistrationModal from "./modals/RegistrationModal";
import VerifyEmailModal from "./modals/VerifyEmailModal";
import LoginModal from "./modals/LoginModal";
import { isRedirectToVerifyPrincipal } from "../../user/ui/utils";
import { ManualApprovalModal } from "./ManualApprovalModal";
import KycVerification from "../../temp/KycVerification";

export enum PATH {
  LOGIN = "login",
  REGISTRATION = "registration",
  RECOVER = "recover",
  VERIFY_EMAIL = "verify",
  REGISTER_SUCCESS = "success",
  TERMS_CONDITION = "terms",
  NEW_USER = "new-user",
  MODAL_TYPE = "user",
  MODE = "app",
  MANUAL_APPROVAL = "manual-approval",
  KYC = "kyc-verification",
}

export interface ModalProps extends Partial<RouteComponentProps> {
  user: UserState;
  content: Partial<ContentfulState>;
  journey: UserJourneyState;
  verificationRequired: React.Dispatch<React.SetStateAction<boolean>>;
  modalType: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalController = () => {
  const location = useLocation();
  const history = useHistory();

  const [verificationRequired, setVerificationRequired] =
    useState<boolean>(false);
  const [modalType, setModalType] = useState<boolean>(false);
  const user = useSelector((app: AppState) => app.user);
  const journey = useSelector((app: AppState) => app.journey);
  const { onboardingpage, global, contentModelStatus, isFetching } =
    useSelector((app: AppState) => app.contentful);

  const content = { onboardingpage, global, contentModelStatus, isFetching };

  const getPath = (str: any, verificationRequired: boolean) => {
    const searchParams = new URLSearchParams(str);
    const type = searchParams.get("type");
    return type;
  };

  const path = getPath(location.search, verificationRequired);



  return (
    <ModalBoundary>
      <ModalRoute
        user={user}
        content={content}
        journey={journey}
        history={history}
        location={location}
        modalType={setModalType}
        verificationRequired={setVerificationRequired}
      >
        {(() => {
          switch (path) {
            case PATH.LOGIN:
              return <LoginModal />;
            case PATH.MANUAL_APPROVAL:
              return <ManualApprovalModal />
            case PATH.REGISTRATION:
              return <RegistrationModal />;
            case PATH.RECOVER:
              return <RecoverPasswordModal />;
            case PATH.VERIFY_EMAIL:
              return <VerifyEmailModal />;
            case PATH.REGISTER_SUCCESS:
              return <RegisterSuccessModal />;
            case PATH.TERMS_CONDITION:
              return <TermsAndConditionModal />;
            case PATH.KYC:
              return <KycVerification />;
            default:
              break;
          }
        })()}
      </ModalRoute>
    </ModalBoundary>
  );
};

export default ModalController;
